// HorizontalTimelineExact.tsx
import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

export interface TimelineStep {
  label: string;
  completed: boolean;
  icon: ReactNode; // 👈 ADD ICON SUPPORT
}

interface Props {
  steps: TimelineStep[];
  disabled?: boolean;
}


export default function WSHorizontalTimeline({ steps }: Props) {
  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#F2FBF7",
        borderRadius: 3,
        p: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {steps.map((step, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
          }}
        >
          {/* Step pill */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: 2,
              py: 1,
              bgcolor: step.completed ? "#DDF6EC" : "#EDEDED",
              borderRadius: 2,
              minWidth: 160,
              justifyContent: "center",
            }}
          >
            {/* ICON COMES FROM PROPS */}
            <Box
              sx={{
                color: step.completed ? "#33B78E" : "#A6A6A6",
                fontSize: 20,
                display: "flex",
                alignItems: "center",
              }}
            >
              {step.icon}
            </Box>

            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 600,
                color: step.completed ? "#1E8A67" : "#7C7C7C",
              }}
            >
              {step.label}
            </Typography>
          </Box>

          {/* Connector line */}
          {index < steps.length - 1 && (
            <Box
              sx={{
                height: 2,
                flexGrow: 1,
                mx: 1,
                bgcolor: steps[index + 1].completed ? "#33B78E" : "#CFCFCF",
              }}
            />
          )}
        </Box>
      ))}
    </Box>
  );
}
